import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import Navbar from './Navbar';
import Footer from './Footer';

function Terms() {
    const { t, lang } = useLanguage();

    const contentTR = (
        <>
            <section>
                <h2>1. Hizmet Tanimi</h2>
                <p>
                    Getiri Hesaplama, yatirim getirisi hesaplama ve finansal planlama araci sunan bir web uygulamasidir.
                    Bu hizmet, kullanicilarin bilesik faiz hesaplamalari yapmasina, yatirim senaryolarini karsilastirmasina
                    ve finansal hedeflerini planlamasina yardimci olmak amaciyla sunulmaktadir.
                </p>
            </section>

            <section>
                <h2>2. Kullanim Kosullari</h2>
                <p>Bu hizmeti kullanarak asagidaki kosullari kabul etmis sayilirsiniz:</p>
                <ul>
                    <li>18 yasindan buyuk oldugunuzu veya yasal vasinizin ebeveyn/vasi iznine sahip oldugunuzu</li>
                    <li>Hesabinizi guvenli tutmaktan sorumlu oldugunuzu</li>
                    <li>Hizmeti yasa disi amaclarla kullanmayacaginizi</li>
                    <li>Diger kullanicilarin haklarini ihlal etmeyeceginizi</li>
                </ul>
            </section>

            <section>
                <h2>3. Hesap Olusturma</h2>
                <p>
                    Hizmetten tam olarak yararlanmak icin bir hesap olusturmaniz gerekmektedir. Hesap olustururken
                    dogru ve guncel bilgiler saglama yukumlulugune sahipsiniz. Hesabinizin guvenliginden siz sorumlusunuz
                    ve sifrenizi baskalariylaaylasmamalisiniz.
                </p>
            </section>

            <section>
                <h2>4. Abonelik ve Odemeler</h2>
                <p>
                    Premium abonelik, aylik veya yillik olarak faturalandirilir. Aboneliginizi istediginiz zaman iptal edebilirsiniz.
                    Iptal durumunda, mevcut faturalandirma donemine kadar hizmetten yararlanmaya devam edersiniz.
                </p>
                <ul>
                    <li>Fiyatlar TL cinsinden belirlenmistir ve KDV dahildir</li>
                    <li>Otomatik yenileme secenegi mevcuttur</li>
                    <li>14 gun icerisinde kosulsuz para iadesi yapilmaktadir</li>
                </ul>
            </section>

            <section>
                <h2>5. Fikri Mulkiyet</h2>
                <p>
                    Bu platformdaki tum icerik, tasarim, logo ve yazilimlar Getiri Hesaplama'ya aittir ve telif haklari ile korunmaktadir.
                    Izinsiz kopyalama, dagitim veya degistirme yasaklanmistir.
                </p>
            </section>

            <section>
                <h2>6. Sorumluluk Sinirlamasi</h2>
                <p>
                    Getiri Hesaplama, yatirim tavsiyesi vermemektedir. Yapilan hesaplamalar bilgilendirme amaclıdır ve
                    yatirim kararlari icin profesyonel danismanlik almaniz onemle tavsiye edilir. Platform, hesaplama
                    sonuclarindan kaynaklanan herhangi bir zarar icin sorumluluk kabul etmemektedir.
                </p>
            </section>

            <section>
                <h2>7. Degisiklikler</h2>
                <p>
                    Bu kullanim sartlarini herhangi bir zamanda degistirme hakkini sakli tutariz. Onemli degisiklikler
                    email yoluyla bildirilecektir. Degisikliklerden sonra hizmeti kullanmaya devam etmeniz, yeni
                    sartlari kabul ettiginiz anlamina gelir.
                </p>
            </section>

            <section>
                <h2>8. Iletisim</h2>
                <p>
                    Bu kullanim sartlari hakkinda sorulariniz icin <Link to="/support">destek sayfamizdan</Link> bizimle
                    iletisime gecebilirsiniz.
                </p>
            </section>
        </>
    );

    const contentEN = (
        <>
            <section>
                <h2>1. Service Description</h2>
                <p>
                    Getiri Hesaplama is a web application that provides investment return calculation and financial planning tools.
                    This service is designed to help users perform compound interest calculations, compare investment scenarios,
                    and plan their financial goals.
                </p>
            </section>

            <section>
                <h2>2. Terms of Use</h2>
                <p>By using this service, you agree to the following conditions:</p>
                <ul>
                    <li>You are over 18 years old or have parental/guardian consent if you are of legal age</li>
                    <li>You are responsible for keeping your account secure</li>
                    <li>You will not use the service for illegal purposes</li>
                    <li>You will not violate the rights of other users</li>
                </ul>
            </section>

            <section>
                <h2>3. Account Creation</h2>
                <p>
                    To fully benefit from the service, you need to create an account. When creating an account,
                    you are obligated to provide accurate and up-to-date information. You are responsible for
                    the security of your account and should not share your password with others.
                </p>
            </section>

            <section>
                <h2>4. Subscription and Payments</h2>
                <p>
                    Premium subscription is billed monthly or annually. You can cancel your subscription at any time.
                    Upon cancellation, you will continue to benefit from the service until the current billing period ends.
                </p>
                <ul>
                    <li>Prices are set in TRY and include VAT</li>
                    <li>Auto-renewal option is available</li>
                    <li>Unconditional refund is available within 14 days</li>
                </ul>
            </section>

            <section>
                <h2>5. Intellectual Property</h2>
                <p>
                    All content, design, logos, and software on this platform belong to Getiri Hesaplama and are
                    protected by copyright. Unauthorized copying, distribution, or modification is prohibited.
                </p>
            </section>

            <section>
                <h2>6. Limitation of Liability</h2>
                <p>
                    Getiri Hesaplama does not provide investment advice. Calculations are for informational purposes only,
                    and it is strongly recommended to seek professional consultation for investment decisions. The platform
                    does not accept any liability for damages arising from calculation results.
                </p>
            </section>

            <section>
                <h2>7. Changes</h2>
                <p>
                    We reserve the right to change these terms of use at any time. Important changes will be
                    notified via email. Continuing to use the service after changes means you accept the new terms.
                </p>
            </section>

            <section>
                <h2>8. Contact</h2>
                <p>
                    For questions about these terms of use, please contact us through our <Link to="/support">support page</Link>.
                </p>
            </section>
        </>
    );

    return (
        <div className="app-container">
            <Navbar />

            <main className="main-content">
                <div className="legal-page">
                    <div className="legal-header">
                        <h1>{t('legal.terms')}</h1>
                        <p className="legal-updated">
                            {t('legal.lastUpdated')}: 01.01.2024
                        </p>
                    </div>

                    <div className="legal-content">
                        {lang === 'tr' ? contentTR : contentEN}
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
}

export default Terms;
